module.exports = __webpack_public_path__ + "img/aplicaciones_web.22ea8a68.jpeg";